var React = require('react');

function YoutubeInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"youtube"),React.createElement("path",{"fill":"#fff","d":"M19.801 6c0 0-0.195-1.379-0.797-1.984-0.762-0.797-1.613-0.801-2.004-0.848-2.797-0.203-6.996-0.203-6.996-0.203h-0.008c0 0-4.199 0-6.996 0.203-0.391 0.047-1.242 0.051-2.004 0.848-0.602 0.605-0.793 1.984-0.793 1.984s-0.199 1.617-0.199 3.238v1.516c0 1.617 0.199 3.238 0.199 3.238s0.195 1.379 0.793 1.984c0.762 0.797 1.762 0.77 2.207 0.855 1.602 0.152 6.801 0.199 6.801 0.199s4.203-0.008 7-0.207c0.391-0.047 1.242-0.051 2.004-0.848 0.602-0.605 0.797-1.984 0.797-1.984s0.199-1.617 0.199-3.238v-1.516c-0.004-1.617-0.203-3.238-0.203-3.238zM7.934 12.594v-5.621l5.402 2.82-5.402 2.801z","key":1})]);
}

YoutubeInline.defaultProps = {"version":"1.1","width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = YoutubeInline;

YoutubeInline.default = YoutubeInline;
